<script>
import { Router, Route } from 'svelte-routing';
import SignIn from './SignIn.svelte';
import SignUp from './SignUp.svelte';
import Read from './Read.svelte';
import Secret from './Secret.svelte';
import AddNote from './AddNote.svelte';
import Notes from './Notes.svelte';
import Note from './Note.svelte';
import { user } from './stores.js';
// import { goto } from '$app/navigation';
import { useNavigate, useLocation } from "svelte-navigator";

// const navigate = useNavigate();
// const location = useLocation();

export let API_URL;

function logout() {
    $user = null;
    window.location = "/signin";
    // const from = ($location.state && $location.state.from) || "/signin";
    // navigate(from, { replace: true });
    // goto("/signin");
  }

</script>

<svelte:head>
  <title>polyreader</title>
</svelte:head>

<Router>
      <!-- Nav -->
      <nav class="container-fluid">
        <ul>
          <li><a href="/" class="contrast"><strong>polyreader</strong></a></li>
        </ul>
        <ul>
            <!-- <li>
                {#if language !== ""}
                Language: <strong>{language}</strong>
                {/if}
            </li> -->
            <li><a href="/read">Read</a></li>
            {#if $user !== null}
            <li><a href="/notes/add">Add note</a></li>
            <li><a href="/notes">Notes</a></li>
            <li><a href="#" on:click={logout}>Log out</a></li>
            {:else}
            <li><a href="/signin">Sign in</a></li>
            <li><a href="/signup">Sign up</a></li>
            {/if}


          </ul>
      </nav><!-- ./ Nav -->
    <div>
        <!-- {#if $user !== null} -->
        <Route path="/notes/add" component={AddNote} API_URL={API_URL} />
        <Route path="/notes/:id" component={Note} API_URL={API_URL} />
        <Route path="/notes" component={Notes} API_URL={API_URL} />
        <!-- {:else} -->
        <Route path="/signin" component={SignIn} API_URL={API_URL} />
        <Route path="/signup" component={SignUp} API_URL={API_URL} />
        <!-- {/if} -->

        <Route path="/read" component={Read} API_URL={API_URL} />
        <Route path="/" component={Notes} API_URL={API_URL} />
        <!-- <Route path="/secret" component={Secret} API_URL={API_URL} /> -->
    </div>


    </Router>